import type { GasMix } from "../types.js";
import { alveolarPressure, depthToAmbient } from "./pressure.js";

export function inspiredN2(depthMsw: number, gas: GasMix): number {
  return alveolarPressure(depthMsw) * gas.fN2;
}

export function inspiredO2(depthMsw: number, gas: GasMix): number {
  return depthToAmbient(depthMsw) * gas.fO2;
}

export function isNitrox(gas: GasMix): boolean {
  return (gas.fHe ?? 0) === 0;
}

export function validateGas(gas: GasMix): void {
  const total = gas.fO2 + gas.fN2 + (gas.fHe ?? 0);
  if (Math.abs(total - 1) > 1e-6) {
    throw new Error(`Gas fractions must sum to 1, got ${total}`);
  }
  if (gas.fO2 < 0 || gas.fO2 > 1 || gas.fN2 < 0 || gas.fN2 > 1) {
    throw new Error(`Invalid gas fractions: O2=${gas.fO2}, N2=${gas.fN2}`);
  }
}
